import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { LoanDetailsService } from '../../../../service/loan-details.service';
import { LoanStatusType } from '../../../../model/loan-status.model';
import { SortingOrder } from '../../../../model/common/Sorting';
import { Loan } from '../../../../model/loan.model';
import { ManualinvestdetailComponent } from '../../../../portfolio-creation/manualinvestdetail/manualinvestdetail.component';
import { MatSort } from '@angular/material/sort';
import moment = require('moment-timezone');
import {Moment} from 'moment';
import {TimeUtil} from '../../../../utils/TimeUtil';
import {UserAddress} from '../../../../model/user-address.model';
import {UserAddressService} from '../../../../service/user-address.service';
import {LoanApplicationService} from '../../../../service/loan-application.service';
import {MatPaginator} from '@angular/material/paginator';
import { LoanApplication } from '../../../../model/loan-application.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { BrowserUtil } from '../../../../../app/utils/browser.util';
import { ConfigService } from '../../../../../app/service/config.service';

interface RecentlyFilledLoan {
  loanApplicationId: string;
  profile: string;
  rating: string;
  roi: number;
  loan_amount: number;
  loan_reason: string;
  location: string;
  timeTakenInLoanFunding: string;
  noOfInvestors: number;
  debt_info: any;
  filled_percentage: number;
}

@Component({
  selector: 'app-recently-filled-loans',
  templateUrl: './recently-filled-loans.component.html',
  styleUrls: ['../../../../../assets/styles/table-styles.scss', './recently-filled-loans.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*', minHeight: "*" })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RecentlyFilledLoansComponent implements OnInit {

  private matDialog: MatDialog;
  private loanDetailsService: LoanDetailsService;
  private loanApplicationService: LoanApplicationService;
  private userAddressService: UserAddressService;
  displayedColumns = [
    'rating', 'roi', 'loanAmount', 'loanPurpose', 'location', 'timeTakenInLoanFunding', 'noOfInvestors', 'borrowerDetails'
  ];
  dataSource = new MatTableDataSource<RecentlyFilledLoan>();
  networkCallInProgress: boolean;
  noOfLoansToBeFetched: number;

  expandedElement: RecentlyFilledLoan | null;
  public isMobile: boolean = false;
  screenWidth: number;

  @ViewChild(MatSort)
  public set matSort(val: MatSort) {
    this.dataSource.sort = val;
  }

  @ViewChild(MatPaginator, { static: false })
  set paginator(value: MatPaginator) {
    if (this.dataSource) {
      this.dataSource.paginator = value;
    }
  }
  ngAfterViewInit() {
    this.screenWidth = window.innerWidth;
    this.isMobile = (<any>window).innerWidth < 500;
    if (this.isMobile) {
      this.displayedColumns = ['rating', 'loanAmount', 'loanPurpose','accordion_arrow'];
    }
  }

  openFromMobile(e, download = false) {

    let webkit = this.browserUtil.nativeWindow.webkit;
    if (webkit) {
        e.preventDefault();
        e.stopPropagation();
        
        let url = e.target.href;
        if (!url) {
            url = e.target.parentNode.href;
        }
        var msg = JSON.stringify({ 'action': (download) ? 'download_file' : 'open_external', 'url': url });
        webkit.messageHandlers.cordova_iab.postMessage(msg);
    }
}
  
  constructor(
    matDialog: MatDialog, 
    loanDetailsService: LoanDetailsService,
    loanApplicationService: LoanApplicationService, 
    userAddressService: UserAddressService,
    private browserUtil: BrowserUtil,
    private configService: ConfigService) {
    this.matDialog = matDialog;
    this.loanDetailsService = loanDetailsService;
    this.loanApplicationService = loanApplicationService;
    this.userAddressService = userAddressService;
    this.noOfLoansToBeFetched = 100;
  }

  async ngOnInit(): Promise<void> {
    this.networkCallInProgress = true;
    const loans = await this.loanDetailsService.getLoansByStatuses([LoanStatusType.DisbursalInitiated,
    LoanStatusType.Disbursed, LoanStatusType.DocumentHardcopyReceived, LoanStatusType.ReadyForDisbursal,
    LoanStatusType.Fulfilled, LoanStatusType.DocumentCollected, LoanStatusType.DocumentVerified],
      'loan_fulfilled_on', SortingOrder.desc, this.noOfLoansToBeFetched);
    this.dataSource.data = await this.populateRecentlyFilledLoansData(loans);

    this.networkCallInProgress = false;
  }

  viewBorrowerDetails(loan) {
    loan.sensitiveDetailsHidden = true;
    this.matDialog.open(ManualinvestdetailComponent, { data: loan, panelClass: 'manual-invest-details-dialog'});
  }

  getPageLengthInPagination(pageLength: number): number {
    return Math.floor(pageLength / 5) * 5;
  }

  private async populateRecentlyFilledLoansData(loans: Loan[]): Promise<RecentlyFilledLoan[]> {
    const recentlyFilledLoans: RecentlyFilledLoan[] = [];
    const recentlyFilledLoansApplicationIds: string[] = loans.map(loan => loan.loanApplicationId);
    const recentlyFilledLoansApplications: LoanApplication[] =
        await this.loanApplicationService.getLoanApplicationsByApplicationIds(recentlyFilledLoansApplicationIds);

    const recentlyFilledLoansApplicationAddressIds: string[] =
        recentlyFilledLoansApplications.map(application => application.addressId);
        
    const recentlyFilledLoansAddress: UserAddress[] = 
        await this.userAddressService.getloansApplicationAddressByIds(recentlyFilledLoansApplicationAddressIds);

    for (const loan of loans) {
      recentlyFilledLoansApplications.forEach(recentlyFilledLoansApplication => {
        if(loan.loanApplicationId === recentlyFilledLoansApplication.id) {
          recentlyFilledLoansAddress.forEach(recentlyFilledLoansAddress => {
            if(recentlyFilledLoansAddress._id === recentlyFilledLoansApplication.addressId) {
              recentlyFilledLoans.push({
                loanApplicationId: loan.loanApplicationId,
                profile: loan.profile,
                rating: loan.rating,
                roi: loan.roi,
                loan_amount: loan.loan_fulfilled_amount,
                loan_reason: loan.loan_reason,
                location: recentlyFilledLoansAddress.city,
                timeTakenInLoanFunding: this.getTimeTakenInLoanFunding(moment(loan.loan_queued_to_be_fulfilled_on[0]).tz('Asia/Kolkata'), moment(loan.loan_accepted_on).tz('Asia/Kolkata')),
                noOfInvestors: loan.lenders_invested.length,
                debt_info: loan.debt_info,
                filled_percentage: loan.filled_percentage,
              });
            }
          })
        }
      })
    }
    return recentlyFilledLoans;
  }

  private getTimeTakenInLoanFunding(loanQueuedToBeFulfilledOn: Moment, loanAcceptedOn: Moment): string {
    const diffInMinutes = moment.duration(loanQueuedToBeFulfilledOn.diff(loanAcceptedOn)).asMinutes();
    return TimeUtil.getTimeFrameBetweenMinutes(diffInMinutes);
  }
  public getSampleFileUrl(): string {
    return this.configService.getPolicyFileUrlByName("sampleLoan");
  }
}
